var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("filterable-list", {
    attrs: { url: _vm.newUrl, naviagatable: false },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(props) {
            return [
              _vm._t("render"),
              _vm._l(props.items.data, function(item) {
                return _c(
                  "div",
                  [_c("renderer", { attrs: { result: item } })],
                  1
                )
              }),
              _vm.hasNext == "True"
                ? _c("load-more", {
                    attrs: {
                      page: props.items.meta ? props.items.meta.pagination : {},
                      current: _vm.page
                    },
                    on: {
                      paginate: function($event) {
                        return _vm.pagination($event)
                      }
                    }
                  })
                : _vm._e()
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3b7727c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b7727c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/videos/VideosPage.vue
// module id = 196
// module chunks = 4